<div class="flex gap-1">
  @for (breadcrumbItem of breadcrumbItems(); track breadcrumbItem.label) {
    <app-breadcrumb-item [breadcrumbItem]="breadcrumbItem"/>
  }
</div>
